export interface ErrorResponseModel {
	timestamp: number;
	error: string;
	message: string;
	path: string;
	code: ClaimsMessagesCode;
	status: number;
}

export enum ClaimsMessagesCode {
	GATEWAY_1002 = 'GATEWAY_1002', // Unknown host
	CLAIMS_1000 = 'CLAIMS_1000', // Unknown host
	CLAIMS_1001 = 'CLAIMS_1001', // Empty URL input source. No URL to call
	CLAIMS_1002 = 'CLAIMS_1002', // UUID already in use
	CLAIMS_1003 = 'CLAIMS_1003', // Response KO from Filemanager
	CLAIMS_1004 = 'CLAIMS_1004', // File must be in a subfolder
	CLAIMS_1005 = 'CLAIMS_1005', // Parent folder name must respect the regex
	CLAIMS_1006 = 'CLAIMS_1006', // File name must be one of the available ones
	CLAIMS_1007 = 'CLAIMS_1007', // Exception while calling send mail operation
	CLAIMS_1008 = 'CLAIMS_1008', // Cannot convert SendMailRequest to JSON String
	CLAIMS_1009 = 'CLAIMS_1009', // Duplicate value not admitted
	CLAIMS_1010 = 'CLAIMS_1010', // Not found
	CLAIMS_1011 = 'CLAIMS_1011', // Date format Error
	CLAIMS_1012 = 'CLAIMS_1012', // Esb Failed. Customer id is null
	CLAIMS_1013 = 'CLAIMS_1013', // Esb Failed. Driver id is null
	CLAIMS_1014 = 'CLAIMS_1014', // Esb Failed. Vehicle plate is null
	CLAIMS_1015 = 'CLAIMS_1015', // Esb Failed. Contract not present
	CLAIMS_1016 = 'CLAIMS_1016', // Contract not active
	CLAIMS_1017 = 'CLAIMS_1017', // Vehicle not found
	CLAIMS_1018 = 'CLAIMS_1018', // Error on ESB call
	CLAIMS_1019 = 'CLAIMS_1019', // Error on OCTO call
	CLAIMS_1020 = 'CLAIMS_1020', // Impossible to lock
	CLAIMS_1021 = 'CLAIMS_1021', // Percent value not admitted
	CLAIMS_1022 = 'CLAIMS_1022', // File is null
	CLAIMS_1023 = 'CLAIMS_1023', // Claims not acceptable
	CLAIMS_1024 = 'CLAIMS_1024', // Not assigned
	CLAIMS_1025 = 'CLAIMS_1025', // Plate is not related to an active contract
	CLAIMS_1026 = 'CLAIMS_1026', // Claims complaint is null
	CLAIMS_1027 = 'CLAIMS_1027', // Claims with passed id not found
	CLAIMS_1028 = 'CLAIMS_1028', // ESB Fail. Connection time out
	CLAIMS_1029 = 'CLAIMS_1029', // Claims' counterparty list is empty
	CLAIMS_1030 = 'CLAIMS_1030', // Claims haven't counterparty with the given id
	CLAIMS_1031 = 'CLAIMS_1031', // Association already present
	CLAIMS_1032 = 'CLAIMS_1032', // Vehicle already sequestred
	CLAIMS_1033 = 'CLAIMS_1033', // Counterparty list must be null
	CLAIMS_1034 = 'CLAIMS_1034', // Esb Failed. Customer not found
	CLAIMS_1035 = 'CLAIMS_1035', // Customer is null
	CLAIMS_1036 = 'CLAIMS_1036', // Damaged is null
	CLAIMS_1037 = 'CLAIMS_1037', // The previous status is not acceptable
	CLAIMS_1038 = 'CLAIMS_1038', // Claims id list must not be null
	CLAIMS_1039 = 'CLAIMS_1039', // Not found claims with id into claims id list and associated with given dossier and working
	CLAIMS_1040 = 'CLAIMS_1040', // Cannot define a type_accident because there aren't cai details and type_accident.
	CLAIMS_1041 = 'CLAIMS_1041', // Counterparty plate must be different from damaged plate
	CLAIMS_1042 = 'CLAIMS_1042', // Contract not valid
	CLAIMS_1043 = 'CLAIMS_1043', // the date_from and date_to must be both present
	CLAIMS_1044 = 'CLAIMS_1044', // Cannot send e-mail
	CLAIMS_1045 = 'CLAIMS_1045', // Type accident must not be null
	CLAIMS_1046 = 'CLAIMS_1046', // Complaint and data accident must not be null
	CLAIMS_1047 = 'CLAIMS_1047', // Cannot recover Customer from ESB
	CLAIMS_1048 = 'CLAIMS_1048', // Policy not found into NEMO
	CLAIMS_1049 = 'CLAIMS_1049', // Company of policy must not be null
	CLAIMS_1050 = 'CLAIMS_1050', // Company of counterparty not found into NEMO
	CLAIMS_1051 = 'CLAIMS_1051', // Company of counterparty must not have id null
	CLAIMS_1052 = 'CLAIMS_1052', // Wounded list is NULL
	CLAIMS_1053 = 'CLAIMS_1053', // Wounded driver not exists
	CLAIMS_1054 = 'CLAIMS_1054', // Cannot insert claim: policy not found
	CLAIMS_1055 = 'CLAIMS_1055', // Error while generating PAI pdf
	CLAIMS_1056 = 'CLAIMS_1056', // PAI pdf not generated
	CLAIMS_1057 = 'CLAIMS_1057', // Impossible insert claim with NO flow
	CLAIMS_1058 = 'CLAIMS_1058', // Claims with same data accident and plate already exists
	CLAIMS_1059 = 'CLAIMS_1059', // Claims with same plate, fistname, lastname counterparty already exists
	CLAIMS_1060 = 'CLAIMS_1060', // Claims with same plate counterparty already exists
	CLAIMS_1061 = 'CLAIMS_1061', // Claims with same firstname and lastname counterparty already exists
	CLAIMS_1062 = 'CLAIMS_1062', // Claims with same type and date accident = today-1
	CLAIMS_1063 = 'CLAIMS_1063', // Claims with date accident = today-1 and same firstname and lastname counterparty already exists
	CLAIMS_1064 = 'CLAIMS_1064', // It's not possible to have cai details with more than one counterparty
	CLAIMS_1065 = 'CLAIMS_1065', // There must be at least one attachment for the wounded person in the emergency room.
	CLAIMS_1066 = 'CLAIMS_1066', // There must be at least one attachment for the deponent.
	CLAIMS_1067 = 'CLAIMS_1067', // Impossible insert CAI without driver side
	CLAIMS_1068 = 'CLAIMS_1068', // Cannot insert a Claim without counterparty and type accident null
	CLAIMS_1069 = 'CLAIMS_1069', // Exists another Exp Notification Type with same notification_type
	CLAIMS_1070 = 'CLAIMS_1070', // Exists another Exp Claims Type with same claims_type
	CLAIMS_1071 = 'CLAIMS_1071', // Claims with date accident = today and same firstname and lastname counterparty already exists
	CLAIMS_1072 = 'CLAIMS_1072', // Claims with date accident = today+1 and same firstname and lastname counterparty already exists
	CLAIMS_1073 = 'CLAIMS_1073', // Claims with  data accident = today-1 and same plate already exists
	CLAIMS_1074 = 'CLAIMS_1074', // Claims with data accident = today+1 and same plate already exists
	CLAIMS_1075 = 'CLAIMS_1075', // Claims with date accident = today-1 and same firstname, lastname and plate counterparty already exists
	CLAIMS_1076 = 'CLAIMS_1076', // Claims with data accident = today and same plate already exists
	CLAIMS_1077 = 'CLAIMS_1077', // Claims with data accident = today+1 and same plate already exists
	CLAIMS_1078 = 'CLAIMS_1078', // Claims with same data accident, plate and type accident already esists
	CLAIMS_1079 = 'CLAIMS_1079', // Claims with  data accident = today-1, same plate and type accident already esists"
	CLAIMS_1080 = 'CLAIMS_1080', // Claims with date accident = today-1 and same plate counterparty already esists"),
	CLAIMS_1081 = 'CLAIMS_1081', // Claims with date accident = today and same firstname, lastname and plate counterparty already esists"),
	CLAIMS_1082 = 'CLAIMS_1082', // Claims with date accident = today+1 and same firstname, lastname and plate counterparty already esists"),
	CLAIMS_1083 = 'CLAIMS_1083', // Claims with date accident = today+1 and same plate counterparty already esists"),
	CLAIMS_1084 = 'CLAIMS_1084', // Authority Error, Claims with id '%s' not associable because it's already associated and it's with counterparty
	CLAIMS_1085 = 'CLAIMS_1085', // Authority Error, Claims with id '%s' not associable because it's already associated and his status is type is '%s'
	CLAIMS_1086 = 'CLAIMS_1086', // Claims not associated with the given dossier and working");
	CLAIMS_1087 = 'CLAIMS_1087', // Concurrency post by complaint operator"),
	CLAIMS_1088 = 'CLAIMS_1088', // It is not possible to change the practical type. There are processing still in progress."),
	CLAIMS_1089 = 'CLAIMS_1089', // Claims id is null"),
	CLAIMS_1090 = 'CLAIMS_1090', // Practice type is null"),
	CLAIMS_1091 = 'CLAIMS_1091', // Practice status is null"),
	CLAIMS_1092 = 'CLAIMS_1092', // Impossible to attach practice to a claim with a different vehicle."),
	CLAIMS_1093 = 'CLAIMS_1093', // The selected claims does not make the refund attribute validated"),
	CLAIMS_1094 = 'CLAIMS_1094', // Impossible to close selected claim because of the status"),
	CLAIMS_1095 = 'CLAIMS_1095', // Impossible to close selected claim because of the type"),
	CLAIMS_1096 = 'CLAIMS_1096', // Authority Error, Claims with id '%s' is not associable because his plate is NULL"),
	CLAIMS_1097 = 'CLAIMS_1097', // Authority Error, Claims with id '%s' is not associable because his plate does not match"),
	CLAIMS_1098 = 'CLAIMS_1098', // Authority Error, Claims with id '%s' is not associable because his status is '%s'"),
	CLAIMS_1099 = 'CLAIMS_1099', // Authority Error, Claims with id '%s' is not associable because it's already associated to working '%s'"),
	CLAIMS_1100 = 'CLAIMS_1100', // Authority Error, Claims with id '%s' is not associable because it's read only"),
	CLAIMS_1101 = 'CLAIMS_1101', // Vehicles not found into Authority"),
	CLAIMS_1102 = 'CLAIMS_1102', // Vehicle with chassis '%s' is under maintenance"),
	CLAIMS_1103 = 'CLAIMS_1103', // Error on Authority call")
	CLAIMS_1104 = 'CLAIMS_1104', // Date_end is less than Date_start"),
	CLAIMS_1105 = 'CLAIMS_1105', // Policy legal cost not present into claims with id ('%s')"),
	CLAIMS_1106 = 'CLAIMS_1106', // Authority Error, Practice already associated with a claims with counterparty. Claim id: ('%s')"),
	CLAIMS_1107 = 'CLAIMS_1107', // Authority Error, Cannot associate claims because one of them is with counterparty. Claim id: ('%s')"),
	CLAIMS_1108 = 'CLAIMS_1108', // Authority Error, Practice already associated with a claims without counterparty but not FUL. Claim id: ('%s')"),
	CLAIMS_1109 = 'CLAIMS_1109', // Authority Error, Cannot associate claims because one of them is without counterparty but not FUL. Claim id: ('%s')"),
	CLAIMS_1110 = 'CLAIMS_1110', // Impossible to parse state from claims to Incidents."),
	CLAIMS_1111 = 'CLAIMS_1111', // Contract id cannot be null. Impossible to call Incidents."),
	CLAIMS_1112 = 'CLAIMS_1112', // Call to incident: bad request"),
	CLAIMS_1113 = 'CLAIMS_1113', // It is not possible to create the zip file, attachments not present in claims with id: ('%s')"),7
	CLAIMS_1114 = 'CLAIMS_1114', // EntrustedTypeEnum not valid"),
	CLAIMS_1115 = 'CLAIMS_1115', // RecipientEnum not valid"),
	CLAIMS_1116 = 'CLAIMS_1116', // Cai Rule not valid"),
	CLAIMS_1117 = 'CLAIMS_1117', // It is not possible to create the zip file, attachments not present in claims with id: ('%s')"),
	CLAIMS_1118 = 'CLAIMS_1118', // Authority Error, Counterparty with id '%s' is not associable because his plate is NULL"),
	CLAIMS_1119 = 'CLAIMS_1119', // Authority Error, Counterparty with id '%s' is not associable because his plate does not match"),
	CLAIMS_1120 = 'CLAIMS_1120', // Repair id list must not be null"),
	CLAIMS_1121 = 'CLAIMS_1121', // Not found counterparty linkable with id into repair id list and associated with given dossier and working"),
	CLAIMS_1122 = 'CLAIMS_1122', // Authority Error, Counterparty with id '%s' not associated with the given dossier and working"),
	CLAIMS_1123 = 'CLAIMS_1123', // Authority Error, Counterparty with plate '%s' not found"),
	CLAIMS_1124 = 'CLAIMS_1124', // For this plate there is a practice for theft not yet closed"),
	CLAIMS_1125 = 'CLAIMS_1125', // Cannot insert another evidence with the same state."),
	CLAIMS_1126 = 'CLAIMS_1126', // Cannot insert another export status type with the same status and flow."),
	CLAIMS_1127 = 'CLAIMS_1127', // Cannot insert another Export supplier code with the same vat number"),
	CLAIMS_1128 = 'CLAIMS_1128', // Authority error: all practice associated must be updated"),
	CLAIMS_1129 = 'CLAIMS_1129', // Authority error: cannot disassociate practice because it's not associated
	CLAIMS_1131 = 'CLAIMS_1131', // Not Allowed Status transition for class ('%s') and center id ('%s') from and to the same Status ('%s')"),
	CLAIMS_1132 = 'CLAIMS_1132', // Not Allowed any Status transition for class ('%s') and center id ('%s') from Status ('%s')"),
	CLAIMS_1133 = 'CLAIMS_1133', // Not valid empty input Class"),
	CLAIMS_1134 = 'CLAIMS_1134', // Both oldStatus and newStatus into checkTransitionStatus() method are required"),
	CLAIMS_1135 = 'CLAIMS_1135', // Not Allowed any Working Status transition for Dossier with Status ('%s'), dossier id ('%s') and working id ('%s')"),
	CLAIMS_1136 = 'CLAIMS_1136', // Incongruous Status transition Dossier --> Working: ('%s') --> ('%s') for dossier id ('%s') and working id ('%s')"),
	CLAIMS_1137 = 'CLAIMS_1137', // Inconsistency error: Not found Quotation Entity"),
	CLAIMS_1138 = 'CLAIMS_1138', // Found Authority Dossier ('%s') with not acceptable status ('%s'). Expected Status is any, except ('%s')"),
	CLAIMS_1139 = 'CLAIMS_1139', // Not Found any Working with id ('%s')"),
	CLAIMS_1140 = 'CLAIMS_1140', // There is no match between the input dossier ('%s') and the dossier related to working ('%s')"),
	CLAIMS_1141 = 'CLAIMS_1141', // There is no match between working type ('%s') for working ('%s') and quotation type ('%s')"),
	CLAIMS_1142 = 'CLAIMS_1142', // Inconsistency error: no Status is present for Quotation with id: ('%s')"),
	CLAIMS_1143 = 'CLAIMS_1143', // Not Found any Quotation ('%s') with status ('%s')"),
	CLAIMS_1144 = 'CLAIMS_1144', // Not Found any Dossier for chassis ('%s')"),
	CLAIMS_1145 = 'CLAIMS_1145', // Error get vehicle status API"),
	CLAIMS_1146 = 'CLAIMS_1146', // Input date must be later or equal than today"),
	CLAIMS_1147 = 'CLAIMS_1147', // Error get Workings Attachments API"),
	CLAIMS_1148 = 'CLAIMS_1148', // Inconsistency error: no Status is present for Working with id: ('%s')"),
	CLAIMS_1149 = 'CLAIMS_1149', // Not Found any Working ('%s') with status ('%s')"),
	CLAIMS_1150 = 'CLAIMS_1150', // Error associating Administration Working with id ('%s') - Exception message: ('%s'), Request: ('%s')")
	CLAIMS_1156 = 'CLAIMS_1156', // Error parsing file
	CLAIMS_1157 = 'CLAIMS_1157', // Error to generate MyALD Link
	CLAIMS_1162 = 'CLAIMS_1162', // Export set is empty, no file generated
	CLAIMS_2001 = 'CLAIMS_2001', // ALD vs ALD: same customer. Active claim.
	CLAIMS_2002 = 'CLAIMS_2002', // ALD vs ALD: same company
	CLAIMS_2003 = 'CLAIMS_2003', // ALD vs ALD: same customer. Passive claim.
	CLAIMS_2004 = 'CLAIMS_2004', // Token error external link
	CLAIMS_2005 = 'CLAIMS_2005', // MyAld error link
	CLAIMS_2006 = 'CLAIMS_2006', // Authority Error, no claims associated with the given dossier and working
	CLAIMS_2007 = 'CLAIMS_2007', // Plates list must not be empty
	CLAIMS_2009 = 'CLAIMS_2009', // Vehicle is aldready returned. takein_date < date_accident it's not possible insert a new claim
	CLAIMS_2010 = 'CLAIMS_2010', // Customer is not authorized to insert claims into NEMO
	CLAIMS_2011 = 'CLAIMS_2011', // Customer is authorized to insert only some type accident into NEMO
	CLAIMS_2013 = 'CLAIMS_2013', // Error no customer risks duplicate are allowed
	CLAIMS_2020 = 'CLAIMS_2020', // Location is required
	CLAIMS_2024 = 'CLAIMS_2024', // Attachment is required
	CLAIMS_2025 = 'CLAIMS_2025', // Attachment is required
	CLAIMS_2032 = 'CLAIMS_2032', // Esiste già un modello di posta elettronica con EVENT, FLOWS, CUSTOMER, TYPE ACCIDENT and LEASING COMPANY specificati
	CLAIMS_2033 = 'CLAIMS_2033', // Nessun risultato trovato con numero pratica ('%s') e numero intervento ('%s')
	CLAIMS_2034 = 'CLAIMS_2034', // Non è possibile inserire il sinistro: data inserimento sinistro > data rientro veicolo + deroga
	INVOICING_2001 = 'INVOICING_2001', // Olsa: Invoice not found in olsa archive"),
	INVOICING_2002 = 'INVOICING_2002', // Olsa: Duplicate invoice in olsa archive"),
	INVOICING_2003 = 'INVOICING_2003', // Olsa: Invoice not found and max attemps reached"),

	CLAIMS_2000 = 'CLAIMS_2000', // Generic Error.
	_REPAIR = '_REPAIR',
	CLAIMS_IMPORT_FILE_KO = 'CLAIMS_IMPORT_FILE_KO',
	CLAIMS_IMPORT_FILE_OK = 'CLAIMS_IMPORT_FILE_OK',
	CLAIMS_SEARCH_CLAIMS_RESULT_VOID = 'CLAIMS_SEARCH_CLAIMS_RESULT_VOID',
	CLAIMS_SEARCH_COUNTERPARTY_RESULT_VOID = 'CLAIMS_SEARCH_COUNTERPARTY_RESULT_VOID',
	CLAIMS_DRAFT_CREATED = 'CLAIMS_DRAFT_CREATED',
	CLAIMS_DRAFT_UPDATED = 'CLAIMS_DRAFT_UPDATED',
	CLAIMS_CREATED = 'CLAIMS_CREATED',
	CLAIMS_UPDATED = 'CLAIMS_UPDATED',
	CLAIMS_ENTITY_CREATED = 'CLAIMS_ENTITY_CREATED',
	CLAIMS_ENTITY_UPDATED = 'CLAIMS_ENTITY_UPDATED',
	CLAIMS_ENTITY_ENABLED = 'CLAIMS_ENTITY_ENABLED',
	CLAIMS_ENTITY_DISABLED = 'CLAIMS_ENTITY_DISABLED',
	CLAIMS_ENTITY_DELETED = 'CLAIMS_ENTITY_DELETED',
	CLAIMS_GENERIC_ERROR = 'CLAIMS_GENERIC_ERROR',
	CLAIMS_GENERIC_RESULT_VOID = 'CLAIMS_GENERIC_RESULT_VOID',
	CLAIMS_CUSTOMER_STATUS_UPDATED = 'CLAIMS_CUSTOMER_STATUS_UPDATED',
	CLAIMS_AUTHORITY_LINK_ENABLED = 'CLAIMS_AUTHORITY_LINK_ENABLED',
	CLAIMS_AUTHORITY_LINK_DISABLED = 'CLAIMS_AUTHORITY_LINK_DISABLED',
	CLAIMS_EXPORT_CLAIMS = 'CLAIMS_EXPORT_CLAIMS',
	CLAIMS_EXPORT_THEFTS = 'CLAIMS_EXPORT_THEFTS',
	VOID_EMAIL_LIST = 'VOID_EMAIL_LIST',
	COUNTERPART_ALD_VS_ALD = 'COUNTERPART_ALD_VS_ALD',
	INCOMPLETE_COUNTER_PART = 'INCOMPLETE_COUNTER_PART',
	EDITABLE_CLAIM = 'EDITABLE_CLAIM',
	ANOTHER_USER_IS_EDITING = 'ANOTHER_USER_IS_EDITING',
	NOT_EDITABLE_CLAIM = 'NOT_EDITABLE_CLAIM',
	CLAIM_NOT_FOUND = 'CLAIM_NOT_FOUND',
	NOT_SAVED_NOTE = 'NOT_SAVED_NOTE',
	SUCCESS_UPDATED_STATUS = 'SUCCESS_UPDATED_STATUS',
	OBJECT_RECEIVED = 'OBJECT_RECEIVED',
	RECEIPTS_CONFIRMED_SUCCESSFULLY = 'RECEIPTS_CONFIRMED_SUCCESSFULLY',
	COUNTERPART_RESPONSIBILITY = 'COUNTERPART_RESPONSIBILITY',
	ONLY_ONE_COUNTERPART_WITH_RESPONSIBILITY = 'ONLY_ONE_COUNTERPART_WITH_RESPONSIBILITY',
	NO_COUNTERPART_RESPONSABILITY_WITH_PASSIVE_CLAIMS = 'NO_COUNTERPART_RESPONSABILITY_WITH_PASSIVE_CLAIMS',
	PO_SENT = 'PO_SENT',
	SUCCESS_CHANGE_TYPE = 'SUCCESS_CHANGE_TYPE',
	SUCCESS_UPLOADED_ATTACHMENT = 'SUCCESS_UPLOADED_ATTACHMENT',
	FILE_DOWNLOAD_KO = 'FILE_DOWNLOAD_KO',
	SUCCESS_APPLIED_CHANGES = 'SUCCESS_APPLIED_CHANGES',
	SUCCESS_ATTACHMENT_VALIDATION = 'SUCCESS_ATTACHMENT_VALIDATION',
	SUCCESS_ATTACHMENTS_VALIDATION = 'SUCCESS_ATTACHMENTS_VALIDATION',
	CONTRACT_UPDATED = 'CONTRACT_UPDATED',
	ATTACHMENT_LIST_LOAD_KO = 'ATTACHMENT_LIST_LOAD_KO',
	CLAIM_TYPE_LIST_LOAD_KO = 'CLAIM_TYPE_LIST_LOAD_KO',
	NOTE_TYPE_LIST_LOAD_KO = 'NOTE_TYPE_LIST_LOAD_KO',
	INSURANCE_COMPANY_LOAD_KO = 'INSURANCE_COMPANY_LOAD_KO',
	INSURANCE_MANAGERS_LOAD_KO = 'INSURANCE_MANAGERS_LOAD_KO',
	SUCCESS_DELETED_ATTACHMENT = 'SUCCESS_DELETED_ATTACHMENT',
	CLAIM_TYPE_LOAD_KO = 'CLAIM_TYPE_LOAD_KO',
	SUCCESS_UPDATE_INVOICES = 'SUCCESS_UPDATE_INVOICES',
	APPROVE_PERSONAL_DATA_PROCESSING = 'APPROVE_PERSONAL_DATA_PROCESSING',
	NO_PERMISSION_FOR_SEEING_CLAIM = 'NO_PERMISSION_FOR_SEEING_CLAIM',
	REASONS_LOAD_KO = 'REASONS_LOAD_KO',
	CLAIMS_COMUNICATION_SUCCESS = 'CLAIMS_COMUNICATION_SUCCESS',
	NO_TEMPLATE_FOR_LEGAL_OR_CONSULTANT = 'NO_TEMPLATE_FOR_LEGAL_OR_CONSULTANT',
	REQUIRED_MAIL_FOR_LEGAL_OR_CONSULTANT = 'REQUIRED_MAIL_FOR_LEGAL_OR_CONSULTANT',
	SUCCESS_ASSIGNED_PRACTICE = 'SUCCESS_ASSIGNED_PRACTICE',
	INCOMPLETE_DRIVER_DATA = 'INCOMPLETE_DRIVER_DATA',
	INCOMPLETE_THEFT_DATA = 'INCOMPLETE_THEFT_DATA',
	NO_COUNTERPART_PRESENT = 'NO_COUNTERPART_PRESENT',
	INCOMPLETE_CAI = 'INCOMPLETE_CAI',
	INCOMPLETE_CLAIM_DECLARATION = 'INCOMPLETE_CLAIM_DECLARATION',
	INCOMPLETE_ATTACHMENT = 'INCOMPLETE_ATTACHMENT',
	SUCCESS_MODIFIED_CONTRACT = 'SUCCESS_MODIFIED_CONTRACT',
	OVER_MAX_RANGE = 'OVER_MAX_RANGE',
	SUCCESS_MODIFIED_POLICY = 'SUCCESS_MODIFIED_POLICY',
	ATTACHMENT_TYPE_LOAD_KO = 'ATTACHMENT_TYPE_LOAD_KO',
	SUCCESS_CLOSED_PRACTICE = 'SUCCESS_CLOSED_PRACTICE',
	SUCCESS_SAVED_PRACTICE ='SUCCESS_SAVED_PRACTICE',
	UNLOCK_PRACTICE_TO_CONTINUE = 'UNLOCK_PRACTICE_TO_CONTINUE',
	SUCCESS_ASSOCIATED_WORKINGS = 'SUCCESS_ASSOCIATED_WORKINGS',
	SUCCESS_DELETED_WORKING = 'SUCCESS_DELETED_WORKING',
	CANNOT_SEE_THEFT_DETAIL = 'CANNOT_SEE_THEFT_DETAIL',
	NO_REPAIR_USER_FOUND = 'NO_REPAIR_USER_FOUND',
	COMPLAINT_INCOMPLETE_INSERTION = 'COMPLAINT_INCOMPLETE_INSERTION',
	CLAIMS_INSERT_WARNING = 'CLAIMS_INSERT_WARNING',

	OPERAZIONE_EFFETTUATA_CORRETTAMENTE = 'OPERAZIONE_EFFETTUATA_CORRETTAMENTE',
}
